import * as React from 'react'
import styled from 'styled-components'
import {theme} from '../theme'

type Props = {
  children?: React.ReactNode
  className?: string
}

export const ErrorBoxBase: React.FC<Props> = ({className, children}) => {
  return <div className={className}>{children}</div>
}

export const ErrorBox = styled(ErrorBoxBase)`
  color: ${theme.color.error.default};
  padding: 10px;
  display: flex;
  align-items: center;
  border-radius: 5px;
  flex-direction: column;
  border: 1px solid ${theme.color.error.light};
  background-color: ${theme.color.error.lightest};
  text-align: center;

  @media only screen and (max-width: ${theme.breaks.mobile}px) {
    padding-top: 5px;
    font-size: ${theme.fontSize.xs};
  }
`
